import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store/store";
import AdminLayout from "./layouts/admin";
import AdminLogin from "./views/admin-login";
import Login from "./views/auth";
import BookingEngine from "./views/booking-engine";
import PaymentSuccessPage from "./views/booking-engine/paymentSuccessPage";
import PaymentErrorPage from "./views/booking-engine/paymentErrorPage";
import VoucherPage from "./views/voucher";
// import Airpay from "./views/booking-engine/airpayPG";
const moment = require('moment-timezone');

moment.tz.setDefault('Asia/Kolkata');

const App = () => {
  const [theme, colorMode] = useMode();
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        // hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ColorModeContext.Provider value={colorMode}>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Routes>
                <Route path="/*" element={<AdminLayout />} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin-login/:token" element={<AdminLogin />} />
                <Route path="/booking/:code" element={<BookingEngine />} />
                <Route path="/payment/success" element={<PaymentSuccessPage />} />
                <Route path="/payment/error" element={<PaymentErrorPage />} />
                <Route path="/voucher/:bookingId" element={<VoucherPage />} />
                {/* <Route path="/booking/:code/payment" element={<Airpay />} /> */}
              </Routes>
            </ThemeProvider>
          </ColorModeContext.Provider>
        </PersistGate>
      </Provider>
    </>
  );
};

export default App;
